<script lang="ts">
	import { Router, Route, navigate } from "svelte-routing";
	import Admin from './components/admin/Admin.svelte';
	import Register from './components/Register.svelte';
	import NotFound from './components/404.svelte';
	import Notification from './components/Notification.svelte';
	import { title } from './stores/titles';
	export let url = "";
</script>

	<Router url="{url}">
		<div class="page is-flex is-flex-direction-column ">
			<header class="titles has-text-centered mb-4">
				<div class="logo is-clickable" on:click={() => navigate('/')}></div>
				<div class="titles--inner pt-6 pb-4">
					<h1>Atout Jeux Online !</h1>
					<h2>{$title}</h2>
				</div>
			</header>
			<div class="aside-image is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only"></div>

			<div class="is-flex is-flex-grow-1">
				<main class="container is-max-desktop has-text-centered">
					<Route path="admin/*"><Admin /></Route>
					<Route path="/"><Register /></Route>
					<Route component={NotFound} />
				</main>
		</div>

			<footer class="footer has-text-centered py-4 mt-4 has-background-dark has-text-light">
				Copyright <a class="has-text-info" href="https://atoutjeux.org">Atout Jeux</a> &copy; {new Date().getFullYear()} -
				<a class="has-text-info" href="mailto:contact@atoutjeux.org">Nous contacter</a>
			</footer>
		</div>

		<Notification />
	</Router>


<style lang="scss" global>
	@import url('https://fonts.googleapis.com/css2?family=Indie+Flower&display=swap');

	@import "./styles/bulma.override.scss";

	.page {
		min-height: calc(100vh - 8px);
	}

	main {
		padding: 1em;
		max-width: 640px;
		margin: 0 auto;
		background: rgba(251, 238, 208, 0.7);
		border-radius: 5px;
	}

	h1 {
		color: $primary;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
		font-family: 'Indie Flower';

		@include until($desktop) {
			font-size: 2em;
			margin-bottom: 0;
		}
	}

	h2 {
		font-family: 'Indie Flower';

		@include until($desktop) {
			margin: 10px 0;
		}
	}

	.titles {
		background: url('../assets/landing.jpg') no-repeat;
		background-size: cover;

		@include from($desktop) {
    	background-position-y: -100px;
		}
    margin: -0.5rem -0.5rem 0;
		
		&--inner {
			background: rgba(255, 255, 255, 0.46);
		}

		@include until($desktop) {
			h2 {
				margin: 10px 0;
			}
		}
	}

	footer {
		margin: 0 -8px;
	}

	.logo {
		background: url('../assets/logo.png') no-repeat;
		position: absolute;
		width: 60px;
		height: 60px;
    background-size: contain;

		@include from($desktop) {
			width: 128px;
			height: 128px;
			margin: 20px;
		}
	}

	$imgGap: 66px;
	.aside-image {
		position: fixed;
		left: calc(50vw + 1024px / 2 - #{$imgGap});
		bottom: 1rem;
		background: url('../assets/oie-rire.png') no-repeat;
		background-size: contain;
		background-position-y: bottom;
    width: calc(((100vw - 1024px) / 2) + #{$imgGap});
		max-width: 200px;
    height: calc(100vh - 1rem);
		z-index: 200;
	}

</style>